<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate"
        >新增分配</el-button
      >
      <el-input
        v-model="listQuery.teacher_name"
        placeholder="请输入教师姓名"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-input
        v-model="listQuery.course_name"
        placeholder="请输入课程名称"
        style="width: 200px"
        class="filter-item"
        clearable
      />
      <el-select
        v-model="listQuery.school_id"
        placeholder="请选择学校"
        clearable
        style="width: 250px"
        class="filter-item"
      >
        <el-option
          v-for="item in school_list"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      学年：<el-date-picker
        v-model="listQuery.school_year"
        type="year"
        class="filter-item"
        placeholder="选择年"
        value-format="yyyy"
      >
      </el-date-picker>
      <el-select
        v-model="listQuery.semester"
        placeholder="请选择学期"
        clearable
        style="width: 150px"
        class="filter-item"
      >
        <el-option label="第一学期" :value="1" />
        <el-option label="第二学期" :value="2" />
      </el-select>

      <el-button class="filter-item" type="primary" @click="handleFilter"
        >搜索</el-button
      >
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
    >
      <el-table-column label="序号" width="95" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="学校名称" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.school.name }}</template>
      </el-table-column>
      <el-table-column label="学年" min-width="110" align="center">
        <template slot-scope="scope"
          >{{ scope.row.school_year }}~{{ scope.row.school_year - 0 + 1 }}
        </template>
      </el-table-column>
      <el-table-column label="学期" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.semester == 1 ? "第一学期" : "第二学期" }}
        </template>
      </el-table-column>
      <el-table-column label="课程名称" min-width="110" align="center">
        <template slot-scope="scope"
          >{{ scope.row.school_course.name }}
        </template>
      </el-table-column>
      <el-table-column label="任教教师" min-width="110" align="center">
        <template slot-scope="scope">{{ scope.row.teacher.name }} </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="200"
        align="center"
        class-name="small-padding fixed-width"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleUpdate(scope.row)"
            >修改</el-button
          >
          <el-button
            size="mini"
            type="danger"
            v-if="scope.row.class_course_num <= 0"
            @click="handleDelete(scope.row.id, '删除')"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :rules="rules" :model="form" label-width="120px">
        <el-form-item label="请选择学年" prop="school_year">
          <el-date-picker
            v-model="form.school_year"
            type="year"
            class="filter-item"
            value-format="yyyy"
            placeholder="选择学年"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="请选择学期" prop="semester">
          <el-select
            v-model="form.semester"
            placeholder="请选择学期"
            clearable
            style="width: 150px"
            class="filter-item"
          >
            <el-option label="第一学期" :value="1" />
            <el-option label="第二学期" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="请选择教师" prop="teacher_id">
          <el-select
            v-model="form.teacher_id"
            placeholder="请选择教师"
            clearable
            style="width: 150px"
            class="filter-item"
          >
            <el-option
              v-for="(item, key) in teachers"
              :key="key"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="请选择学校" prop="school_ids">
          <el-table size="mini" :data="form.school_ids" border fit>
            <el-table-column label="学校" align="center" min-width="60">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.id"
                  placeholder="请选择学校"
                  clearable
                  style="width: 150px"
                  class="filter-item"
                  :disabled="dialogStatus == 'update' ? true : false"
                  @change="schoolCourse($event, scope.$index, 1), Scids()"
                >
                  <el-option
                    v-for="item in school_list"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              size="mini"
              label="操作"
              align="center"
              min-width="50"
              v-if="dialogStatus != 'update'"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handelAttrDel(scope.$index, 1)"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handelAttrUp(scope.$index, 1)"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handelAttrDown(scope.$index)"
                  >下移</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-button
            class="button-new-tag"
            size="small"
            @click="add(1)"
            v-if="dialogStatus != 'update'"
            >+ 添加</el-button
          >
        </el-form-item>

        <el-form-item label="请选择课程" prop="school_course_ids">
          <el-table size="mini" :data="form.school_course_ids" border fit>
            <el-table-column label="课程" align="center" min-width="60">
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.id"
                  placeholder="请选择课程"
                  clearable
                  style="width: 150px"
                  class="filter-item"
                  :disabled="dialogStatus == 'update' ? true : false"
                  @change="schoolCourse($event, scope.$index, 2), coursesDis()"
                >
                  <el-option
                    v-for="item in courses"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              size="mini"
              label="操作"
              align="center"
              min-width="50"
              v-if="dialogStatus != 'update'"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="handelAttrDel(scope.$index, 2)"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handelAttrUp(scope.$index, 2)"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="handelCourseDown(scope.$index)"
                  >下移</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-button
            class="button-new-tag"
            size="small"
            @click="add(2)"
            v-if="dialogStatus != 'update'"
          >
            + 添加
          </el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click="saveData"
          :loading="btnLoading"
          v-if="dialogStatus != 'update'"
        >
          确定
        </el-button>
        <el-button
          v-else
          type="primary"
          @click="saveData1"
          :loading="btnLoading"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import LogoVue from "../layout/components/Sidebar/Logo.vue";

export default {
  data() {
    return {
      list: [],
      total: null,
      listLoading: false,
      school_list: [],
      courses: [],
      listQuery: {
        page: 1,
        limit: 10,
        course_name: "",
        school_name: "",
        teacher_name: "",
        school_year: "",
        semester: "",
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "修改",
        create: "新增",
      },
      teachers: [],
      form: {
        id: "",
        school_year: "",
        end_year: "",
        semester: "",
        teacher_id: "",
        school_ids: [{ id: "" }],
        school_course_ids: [{ id: "" }],
      },
      rules: {
        school_year: [
          { required: true, message: "请选择学年", trigger: "blur" },
        ],
        semester: [
          { required: true, message: "请选择学期", trigger: "change" },
        ],
        teacher_id: [
          { required: true, message: "请选择教师", trigger: "change" },
        ],
        school_ids: [
          {
            type: "array",
            required: true,
            message: "学校不能为空",
            trigger: "change",
          },
        ],
        school_course_ids: [
          {
            type: "array",
            required: true,
            message: "课程不能为空",
            trigger: "change",
          },
        ],
      },
      btnLoading: false,
    };
  },
  created() {
    this.getSchoolList();
    this.getCourseList();
    this.getList();
    this.getTeacherList(1);
  },
  watch: {
    // "form.school_ids"(newValue, oldValue) {
    //    console.log(newValue,oldValue);
    // },
    // "form.school_course_ids"(newValue, oldValue) {
    //   //  console.log(newValue,oldValue);
    // },
  },
  methods: {
    getTeacherList(v) {
      var url = null;
      if (v == 1) {
        url = "/api/backend/teacher/eSportslist";
      } else {
        url = "/api/backend/teacher/list";
      }
      request({
        url: url,
        method: "get",
        params: {
          limit: 99999999999999,
          not_status: 3,
          is_normal: 1,
        },
      }).then((response) => {
        this.teachers = response.data.data;
      });
    },
    schoolCourse(e, index, key) {
      if (key == 1) {
        this.form.school_ids[index].id = e;
      } else {
        this.form.school_course_ids[index].id = e;
      }
      // this.$forceUpdate(); //强制更新
    },
    getCourseList() {
      request({
        url: "/api/backend/course/list",
        method: "get",
        params: {
          limit: 999999999999,
          school_id:0
        },
      }).then((response) => {
        this.courses = response.data.data;
        this.courses.forEach((item) => {
          item.disabled = false;
        });
      });
    },
    getSchoolList() {
      request({
        url: "/api/backend/school/list",
        method: "get",
        params: { limit: 9999999 },
      }).then((response) => {
        this.school_list = response.data.data;
        this.school_list.forEach((item) => {
          item.disabled = false;
        });
      });
    },
    handelAttrDown(index) {
      if (index >= this.form.school_ids.length - 1) {
        return;
      }
      this.form.school_ids.splice(
        index + 1,
        0,
        this.form.school_ids.splice(index, 1)[0]
      );
    },
    handelCourseDown(index) {
      if (index >= this.form.school_course_ids.length - 1) {
        return;
      }
      this.form.school_course_ids.splice(
        index + 1,
        0,
        this.form.school_course_ids.splice(index, 1)[0]
      );
    },
    handelAttrUp(index, key) {
      if (index == 0) {
        return;
      }
      if (key == 1) {
        this.form.school_ids.splice(
          index - 1,
          0,
          this.form.school_ids.splice(index, 1)[0]
        );
      } else if (key == 2) {
        this.form.school_course_ids.splice(
          index - 1,
          0,
          this.form.school_course_ids.splice(index, 1)[0]
        );
      }
    },
    handelAttrDel(index, key) {
      if (key == 1) {
        this.Scids();
        this.form.school_ids.splice(index, 1);
      } else if (key == 2) {
        this.coursesDis();
        this.form.school_course_ids.splice(index, 1);
      }
    },
    add(key) {
      if (key == 1) {
        this.form.school_ids.push({ id: "" });
        this.Scids();
      } else if (key == 2) {
        this.form.school_course_ids.push({ id: "" });
        this.coursesDis();
      }
    },
    Scids() {
      this.school_list.forEach((item) => {
        item.disabled = false;
      });
      this.form.school_ids.forEach((item) => {
        let index = this.school_list.find((value) => value.id == item.id);
        if (index) {
          index.disabled = true;
        }
      });
    },
    coursesDis() {
      this.courses.forEach((item) => {
        item.disabled = false;
      });
      this.form.school_course_ids.forEach((item) => {
        let index = this.courses.find((value) => value.id == item.id);
        if (index) {
          index.disabled = true;
        }
      });
    },
    getList() {
      this.listLoading = true;
      request({
        url: "/api/backend/course/distributionList",
        method: "get",
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data;
        this.total = response.data.total;
        this.listLoading = false;
      });
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        school_year: "",
        end_year: "",
        semester: "",
        school_ids: [{ id: "" }],
        school_course_ids: [{ id: "" }],
      };
    },
    handleCreate() {
      this.resetForm();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.school_list.forEach((item) => {
        item.disabled = false;
      });
      this.courses.forEach((item) => {
        item.disabled = false;
      });
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign({}, row);
      this.form.school_ids = [];
      this.form.school_ids.push({ id: this.form.school_id });
      this.form.school_course_ids = [];
      this.form.school_course_ids.push({ id: this.form.school_course_id });
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      let courselids = [];
      let schoolids = [];
      this.form.school_course_ids.forEach((item) => {
        courselids.push(item.id);
      });
      this.form.school_ids.forEach((item) => {
        schoolids.push(item.id);
      });
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.school_course_ids = courselids;
          this.form.school_ids = schoolids;
          this.btnLoading = true;
          request({
            url: "/api/backend/course/distributionDetail",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    saveData1() {
      let courselids = [];
      let schoolids = [];
      this.form.school_course_ids.forEach((item) => {
        courselids.push(item.id);
      });
      this.form.school_ids.forEach((item) => {
        schoolids.push(item.id);
      });

      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.form.school_course_id = courselids[0];
          this.form.school_id = schoolids[0];
          this.btnLoading = true;
          request({
            url: "/api/backend/course/distributionStore",
            method: "post",
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false;
              this.dialogFormVisible = false;
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.getList();
            })
            .catch((err) => {
              this.btnLoading = false;
            });
        }
      });
    },
    //上下架
    handleDelete(val, text) {
      this.$confirm("此操作将" + text + "该分配, 是否继续?", "提示", {
        type: "warning",
      })
        .then(() => {
          request({
            url: "/api/backend/course/distributionDel",
            method: "post",
            data: { id: val },
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功",
            });
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
